import { useQuery } from '@apollo/client';
import { ReactNode, useEffect, useState } from 'react';
import { GetContentUrl } from '~/graphql';
import { Content, ContentContext } from '.';
import content from 'utils/__tests__/exampleContent.json'; // mock data for local development

export const ContentProvider = ({ children }: { children: ReactNode }) => {
    const { data, error: queryError, loading: queryLoading } = useQuery(GetContentUrl);
    const url = data?.getContentUrl?.url;

    const [json, setJson] = useState<Content[] | null>(null);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [fetchError, setFetchError] = useState<Error | null>(null);

    useEffect(() => {
        if (!url) return;

        const fetchJson = async () => {
            setFetchLoading(true);
            setFetchError(null);
            try {
                const response = await fetch(url);
                const jsonData = await response.json();

                // console.log('jsonData', jsonData);

                setJson(jsonData);
            } catch (err) {
                setFetchError(err as Error);
            } finally {
                setFetchLoading(false);
            }
        };

        fetchJson();
    }, [url]);

    return (
        <ContentContext.Provider
            value={{
                content: import.meta.env.DEV ? content : json,
                loading: queryLoading || fetchLoading,
                error: (queryError || fetchError) ?? null,
            }}
        >
            {children}
        </ContentContext.Provider>
    );
};
